import { decodeToken, hasRole, getStoredEnvironment } from 'setup/SetupAxios'
import { GluonEnvironment, GluonRole, isMobileHomeOnlyOperator } from '@numeo/types-core'

export const MOBILE_HOME_EDITOR_PATHS = ['/mobile-home-layout', '/mobile-promo-pages']

const isDev = (): boolean => getStoredEnvironment() === GluonEnvironment.DEVELOPMENT

const isAdmin = (): boolean => hasRole(GluonRole.ADMIN)

const isPM = (): boolean => hasRole(GluonRole.PM)

/** Whether the user holds only the mobile-home role: every page but the two editors is closed to them. */
export const isMobileHomeOnly = (): boolean => isMobileHomeOnlyOperator(decodeToken()?.roles)

/** Whether the user can access admin-level pages (Applications, Billing, System Config) */
export const hasAdminPageAccess = (): boolean => {
    if (isMobileHomeOnly()) return false
    if (isDev()) return true
    return isAdmin() || isPM()
}

/** Whether the user can open the Mobile Home Layout and Mobile Promo Pages editors */
export const canEditMobileHome = (): boolean => hasAdminPageAccess() || isMobileHomeOnly()

/** Whether the user can impersonate (login as) application users */
export const canLoginAsUser = (): boolean => !isMobileHomeOnly() && (isDev() || isAdmin())

/** Whether the user can edit application JSON config */
export const canEditApplicationJson = (): boolean => !isMobileHomeOnly() && (isDev() || isAdmin())

/** Whether the user can start the broker register run (FMCSA, then DAT) from Gluon. The server checks the same role. */
export const canRunBrokerRegister = (): boolean => !isMobileHomeOnly() && isAdmin()

/** Whether the user can hard-delete applications */
export const canDeleteApplication = (): boolean => !isMobileHomeOnly() && (isDev() || isAdmin())
